export default __webpack_public_path__ + "static/media/hecho.c95f53fd.png";